import StackAPI from '../../../lib/StackAPI'
import Article from '../types/Article'
import { captureException } from '@sentry/react'
import { dateTime } from '@/utils/dateTools'

const ENDPOINT = '/api/partners/articles'
const DEFAULT_LIMIT = 50
const DEFAULT_OFFSET = 0

type Params = {
  start: Date
  end: Date
  partnerType: string
  partnerId?: number
  publisherId?: number
  limit?: number
  offset?: number
}

type RequestParams = { [key: string]: number | string | undefined }

const formatDateRange = (params: Params) => {
  const startOfDay = dateTime(params.start)
    .startOf('day')
    .minus({ days: 6 })
    .toUTC()
    .toISO()

  const endOfDay = dateTime(params.end)
    .endOf('day')
    .plus({ days: 6 })
    .toUTC()
    .toISO()

  return `${startOfDay},${endOfDay}`
}

const addFilters = (params: Params, requestParams: RequestParams) => {
  requestParams['filter[status]'] = 2
  requestParams['filter[published_range]'] = formatDateRange(params)

  switch (params.partnerType) {
    case 'affiliate':
      requestParams['filter[affiliate_id]'] = params.partnerId
      break
    case 'publisher':
      requestParams['filter[publisher_id]'] = params.partnerId
      break
  }
  requestParams.include = params.partnerType
}

const addPagination = (params: Params, requestParams: RequestParams) => {
  requestParams['page[limit]'] = params.limit || DEFAULT_LIMIT
  requestParams['page[offset]'] = params.offset || DEFAULT_OFFSET
}

const addSort = (_: Params, requestParams: RequestParams) => {
  requestParams.sort = 'published_at'
}

export const getArticles = async (params: Params): Promise<Article[]> => {
  const { get } = StackAPI()
  const requestParams: RequestParams = {}

  addFilters(params, requestParams)
  addPagination(params, requestParams)
  addSort(params, requestParams)

  return await get<{ data: Article[] }>({
    path: ENDPOINT,
    params: requestParams
  })
    .then(({ status, data }) => (status === 200 ? data.data : []))
    .catch((error) => {
      captureException(error, { extra: { params } })
      return []
    })
}
